<template>
  <div class="f2g-wind-container">
    <div class="etopup-tempate">
      <div class="title-bundles-details">{{content["myf2g.topup.title"]}}</div>
      <div 
        class="mini-title-offers"
      >{{content["myf2g.topup.subtitle"]}}
      </div>
      <div id="enable-pop-up-msg" class="paypal-element" style="display:none;">
        {{content["myf2g.topup.message1"]}}
      </div>
      <div class="row row-f2g">
        <div class="col-md-8 col-xs-12 col-sm-12">
          <img
            src="/ext_files/prepaid/f2g/images/step_1@2x.png"
            class="img-step-etopup hidden-sm hidden-xs"
          />
          <div class="hidden-lg hidden-md steps-title-xs">{{content["myf2g.topup.titleStep1"]}}</div>
          <div class="bold-title-etop">{{content["myf2g.topup.message2"]}}</div>
          <div class="hidden-md hidden-lg amounts-xs-box">

            <div 
              class="check-box-amount"
              v-for="amountObject in topUpAmounts"
              v-bind:key="amountObject.amount"
              v-bind:class="{'active-check-box-amount' :  amountObject.amount === selectedAmount}"
              v-on:click="getSelectedAmount(amountObject.amount)"
            >

              <div class="ampount-xs">{{amountObject.amount}}</div>
              <svg
                class="svg-box-amounts"
                width="32px"
                height="32px"
                viewBox="0 0 32 32"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <desc>Created with Sketch.</desc>
                <g
                  id="Icon/Bundle/bonus"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <path
                    d="M24.9278222,32 C27.2041956,32 29.0554667,30.1486222 29.0554667,27.8723556 L29.0554667,11.8766222 C29.0554667,9.60024889 27.2040889,7.74897778 24.9278222,7.74897778 L20.0236444,7.74897778 L22.1514311,5.86147556 C22.8806044,5.21425778 23.2819911,4.34481778 23.2819911,3.41148444 C23.2819911,2.47815111 22.8806044,1.60871111 22.1514311,0.961493333 C20.7056,-0.320462222 18.3512533,-0.320462222 16.9055644,0.961493333 L16.1555556,1.62677333 L15.4069333,0.96288 C13.9611022,-0.319075556 11.6067556,-0.319075556 10.1610667,0.96288 C9.43189333,1.60871111 9.03050667,2.47953778 9.03050667,3.41287111 C9.03050667,4.34620444 9.43189333,5.21564444 10.1610667,5.86286222 L12.2888533,7.75036444 L7.38325333,7.74897564 C5.10688,7.74897564 3.25560889,9.60035342 3.25560889,11.8766201 L3.25560889,27.8723534 C3.25560889,30.1487268 5.10837333,32 7.38325333,32 L24.9278222,32 Z M24.9278222,9.29713529 C26.3500444,9.29713529 27.5083733,10.4541867 27.5083733,11.8777956 L27.5069842,27.8721067 C27.5069842,29.2943289 26.350042,30.4526578 24.9264331,30.4526578 L19.7666108,30.4512686 L19.7666108,9.29713529 L24.9278222,9.29713529 Z M11.1873778,4.70417778 C10.7943111,4.35556622 10.5776711,3.89724444 10.5776711,3.41251556 C10.5776711,2.92778667 10.7943396,2.46947556 11.1873778,2.12085333 C12.0526578,1.35420444 13.5151644,1.35420444 14.3790578,2.12085333 L16.1554489,3.69585778 L17.93184,2.12085333 C18.79712,1.35420444 20.2596267,1.35420444 21.12352,2.12085333 C21.5165867,2.46946489 21.7332267,2.92778667 21.7332267,3.41251556 C21.7332267,3.89724444 21.5165582,4.35555556 21.12352,4.70417778 L17.9596444,7.51111111 C17.8568676,7.60139022 17.742976,7.679168 17.622144,7.75000178 L14.6901973,7.75000178 C14.5693653,7.68055822 14.4554738,7.60278044 14.3526969,7.51111111 L11.1873778,4.70417778 Z M4.80408889,11.8764444 C4.80408889,10.4542222 5.96103111,9.29589333 7.38464,9.29589333 L12.5444622,9.29589333 L12.5444622,30.4514489 L7.38321778,30.4514489 C5.96099556,30.4514489 4.80266667,29.2945067 4.80266667,27.8708978 L4.80408889,11.8764444 Z"
                    id="Shape"
                    fill="#DBE442"
                  />
                </g>
              </svg>
              <div class="text-amount-etopup-table" v-if="locale === 'en_US'" v-html="amountObject.bonusResponsiveMessageEN">
              </div>
              <div class="text-amount-etopup-table" v-else v-html="amountObject.bonusResponsiveMessage">
              </div>
            </div>
            
          </div>

          <div class="hidden-sm hidden-xs">
            <div
              v-for="(amountObject, index) in topUpAmounts"
              v-bind:key="amountObject.amount"
              v-bind:class="['table-etopup-amount','row','row-f2g',{'border-radius-top' :  index ==0},'hidden-sm', 'hidden-xs']"
              v-on:click="getSelectedAmount(amountObject.amount)"
            >
              <div class="col-md-2 padding-0">
                <div class="amount-etopup-table">
                  <div class="radio-items-f2g">
                    <input
                      type="radio"
                      :id="amountObject.amount"
                      name="amount"
                      :value="amountObject.amount"
                    />
                    <label :for="amountObject.amount">{{amountObject.amount}}€</label>
                  </div>
                </div>
              </div>
              <div class="col-md-10 padding-0">
                <div class="text-amount-etopup-table" v-if="locale === 'en_US'" v-html="amountObject.bonusMessageEN">
                </div>
                <div class="text-amount-etopup-table" v-else v-html="amountObject.bonusMessage">
                </div>
              </div>
            </div>

            <div class="table-etopup-amount row row-f2g" v-on:click="getSelectedAmount('Other')">
              <div class="col-md-10 padding-0">
                <div class="amount-etopup-table">
                  <div class="radio-items-f2g">
                    <input type="radio" id="Other" name="amount" value />
                    <label for="ritemb"></label>
                  </div>
                  <div>
                    <div class="bold-other-amount">{{content["myf2g.topup.message4"]}}</div>
                    <div
                      class="medium-other-amount"
                    >{{content["myf2g.topup.message5"]}}{{minTopUp}} {{content["myf2g.topup.message6"]}}{{maxTopUp}}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-2 padding-0">
                <input
                  type="text"
                  name="fname"
                  class="input-etopup"
                  v-model="userAmount"
                  v-on:keyup="fixUserAmount(userAmount)"
                  value
                  placeholder="€"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xs-12 col-sm-12 right-side-items">
          <img
            src="/ext_files/prepaid/f2g/images/step_2@2x.png"
            class="img-step-etopup hidden-xs hidden-xs"
          />
          <div class="hidden-lg hidden-md steps-title-xs">{{content["myf2g.topup.titleStep2"]}}</div>
          <div class="bold-title-etop">{{content["myf2g.topup.message3"]}}</div>

          <div class="hidden-md hidden-lg amounts-xs-box payment-xs-box">
            <div
              class="check-box-amount"
              v-on:click="choseMethod('Credit')"
              v-bind:class="{'active-check-box-amount' :  paymentOption === 'Credit'}"
            >

              <div class="xs-title-payment">{{content["myf2g.topup.label1"]}}</div>
              <img src="/ext_files/prepaid/f2g/images/payment-card.svg">
            </div>
          </div>
          <div class="container-blue-btn btn-payment-etopup hidden-lg hidden-md">
            <div
              class="overlay-button-container"
              v-bind:class="{'disabled-button' :  !(amountIsEligible && hasChoosenMethod)}"
            >
              <input
                type="submit"
                :value="'Πληρωμή ' + selectedAmount+'€'"
                class="container-button"
                v-bind:class="{'blue-btn' : amountIsEligible && hasChoosenMethod}"
                v-on:click="pay()"
              />
            </div>
          </div>
          <div class="hidden-xs hidden-sm">
            <div
              class="table-etopup-amount row row-f2g border-radius-top"
              v-on:click="choseMethod('Credit')"
            >
              <div class="col-md-12 padding-0">
                <div class="amount-etopup-table">
                  <div class="radio-items-f2g">
                    <input type="radio" id="Credit" name="payment" value="ropt2" />
                    <label for="ritemb">{{content["myf2g.topup.label1"]}}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-etopup-amount row row-f2g">
              <div class="col-md-2 padding-0"></div>
              <div class="col-md-10 padding-0">
                <img src="/ext_files/prepaid/f2g/images/payment-card.svg">
              </div>
            </div>

            <div class="table-etopup-amount row row-f2g">
              <div class="col-md-12 padding-0">
                <div
                  id="buttonContainer"
                  v-bind:class="['overlay-button-container',{'disabled-button' :  !(amountIsEligible && hasChoosenMethod)}]"
                >
                  <input
                    id="myf2g-topup-step1"
                    type="submit"
                    :value="content['myf2g.topup.button'] + ' ' + selectedAmount+'€'"
                    v-bind:class="['container-button',{'blue-btn' : amountIsEligible && hasChoosenMethod}]"
                    v-on:click="pay()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="title-quicklink4" v-html="content['f2g.topup.terms']"></div>
      </div>
    </div>
  </div>
</template>


<script>
// import $ from "jquery";
import axios from "axios";
export default {
  name: "PaymentOptions",
  data: function() {
    return {
      selectedAmount: 0,
      userAmount: "",
      amountIsEligible: false,
      hasChoosenMethod: false,
      getPaypalTokenResponse: '',
      paymentOption: '',
      content: '',
      modalInitialized: false
    };
  },
  created() {
    let self = this;

    /************************
     *** WCS service call ***
     ************************/

    let configWCS = {
      sessionKey: "wcs_topup",
      axiosConfig: {
      method: "get",
        url: '/gr/f2g/vueContentService/',
        params: {
          ciKey: 'myf2gtopup',
          locale: self.locale
        }
      }
    }

    this.fetchDataFromWCS(configWCS)
        .then(response => {
          console.log(JSON.stringify(response))
          self.content = response
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          console.log("finally");
        });

    this.getUserProfileAndTariffs();
    this.$nextTick(function() {
      this.numbersOnly();
    });
    this.$nextTick(function() {
      this.choseMethod('Credit')
    });
  },
  updated() {
    if ($(".open-as-modal").length !== 0 && this.modalInitialized === false ) {
                //initialize terms modal
                $(".open-as-modal").each(function(index, value) {
                    $(this).animatedModal({
                      animatedIn:'bounceIn',
                      animatedOut:'bounceOut',
                      animationDuration:'.6s',
                      color:'#FFFFFF',
                      // Callbacks
                      beforeOpen: function() {
                          console.log("The animation was called");
                      },           
                      afterOpen: function() {
                          console.log("The animation is completed");
                      }, 
                      beforeClose: function() {
                          console.log("The animation was called");
                      }, 
                      afterClose: function() {
                          console.log("The animation is completed");
                      }
                  });
                });
                this.modalInitialized = true;

    }
    
  },
  computed: {
    getUserProfileAndTariffsObject() {
      return this.$store.state.userProfileAndTariffsObject;
    },
    topUpAmounts() {
      if (this.$store.state.userProfileAndTariffsObject.errorCode === "OK") {
        return this.$store.state.userProfileAndTariffsObject
          .prepaidTariffTopUpInfo.resultJsonObject.prepaidTariff.topUpAmountsExtended;
      } else {
        return [];
      }
    },
    minTopUp() {
      if (this.$store.state.userProfileAndTariffsObject.errorCode === "OK") {
        return this.$store.state.userProfileAndTariffsObject
          .prepaidTariffTopUpInfo.resultJsonObject.prepaidTariff.minTopUp;
      } else {
        return 0;
      }
    },
    maxTopUp() {
      if (this.$store.state.userProfileAndTariffsObject.errorCode === "OK") {
        return this.$store.state.userProfileAndTariffsObject
          .prepaidTariffTopUpInfo.resultJsonObject.prepaidTariff.maxTopUp;
      } else {
        return 0;
      }
    },
    token() {
      return this.$store.state.token;
    },
    cardAndRecurringInfoObject() {
      return this.$store.state.cardAndRecurringInfoObject;
    },
    getLocale() {
      var locale;
      if ($("body").data("locale") == "el_GR") {
        locale = "el";
      } else {
        locale = "en";
      }
      return locale;
    },
    email() {
      return this.$store.state.email;
    },
    locale() {
      return this.$store.state.locale;
    },
    loginInfo() {
      return this.$store.state.loginInfo;
    }
  },
  methods: {
    getUserProfileAndTariffs() {
      var token = this.token;
      var self = this;
      this.$store.commit("showLoader");
       var getUserProfileAndTariffsResponse = sessionStorage.getItem(
          "getUserProfileAndTariffs_" + "F2G_" + token
        );
        

        if (getUserProfileAndTariffsResponse == null){
          axios({
            method: "post",
            url: "/mpay/getUserProfileAndTariffs",
            data: { token: token, tokenFLag: "1", locale: this.getLocale }
          })
            .then(response => {
              if (response.data.errorCode === "OK") {
                console.log(
                  "getUserProfileAndTariffs response: " +
                    JSON.stringify(response.data)
                );
                sessionStorage.setItem(
                  "getUserProfileAndTariffs_" + "F2G_" + self.token,
                  JSON.stringify(response.data)
                );
                this.$store.commit("setUserProfileAndTariffs", response.data);

                this.$store.commit("hideLoader");

                //case of warning modal
                if(response.data.forcePersonalData){
                  this.$store.commit("showWarningModal", true);
                  this.$store.commit("forcePersonalDataMessage", response.data.forcePersonalDataMessage);
                }
              } else {
                console.log(
                  "getUserProfileAndTariffs response: " +
                    JSON.stringify(response.data)
                );
                if (
                  response.data.fault != undefined &&
                  response.data.fault.faultCode == 19
                ) {
                  var faultDescription = response.data.fault.faultDescription;
                  this.$store.commit("setFaultDescription", faultDescription);
                }else if( response.data.fault != undefined && response.data.fault.faultCode == 25 ){
                  var forcePersonalDataErrorMessage = response.data.forcePersonalDataErrorMessage;
                  var faultDescription = response.data.fault.faultDescription;
                  this.$store.commit("setFaultDescription", faultDescription);
                  this.$store.commit("forcePersonalDataErrorMessage", forcePersonalDataErrorMessage); 
                }
                this.$store.commit("showErrorComponent", true);
                this.$store.commit("hideLoader");
              }
            })
            .catch(error => {
              console.log(
                "getUserProfileAndTariffs responded with error: " + error
              );
              this.$store.commit("showErrorComponent", true);
              this.$store.commit("hideLoader");
            })
            .finally(() => {
              if ($(".open-as-modal").length !== 0 && self.modalInitialized === false ) {
                  //initialize terms modal
                  $(".open-as-modal").each(function(index, value) {
                      $(this).animatedModal({
                        animatedIn:'bounceIn',
                        animatedOut:'bounceOut',
                        animationDuration:'.6s',
                        color:'#FFFFFF',
                        // Callbacks
                        beforeOpen: function() {
                            console.log("The animation was called");
                        },           
                        afterOpen: function() {
                            console.log("The animation is completed");
                        }, 
                        beforeClose: function() {
                            console.log("The animation was called");
                        }, 
                        afterClose: function() {
                            console.log("The animation is completed");
                        }
                    });
                  });
                  self.modalInitialized = true;

                }
              this.$store.commit("hideLoader");

            });
        }else{
          var parsedData = JSON.parse(getUserProfileAndTariffsResponse);
          if(parsedData.forcePersonalData){
            this.$store.commit("showWarningModal", true);
            this.$store.commit("forcePersonalDataMessage", parsedData.forcePersonalDataMessage);
          }
          this.$store.commit("setUserProfileAndTariffs", JSON.parse(getUserProfileAndTariffsResponse));
          this.$store.commit("hideLoader");
        }
      
    },
    getSelectedAmount(amount) {
      this.userAmount = "";
      if (amount == "Other") {
        this.selectedAmount = 0;
        this.amountIsEligible = false;
      } else {
        this.selectedAmount = amount;
        this.amountIsEligible = true;
        this.$store.commit("setAmount", this.selectedAmount);
      }

      document.getElementById(amount).checked = true;

      console.log(this.selectedAmount);
    },
    numbersOnly: function() {
      $(".input-etopup").on("keypress", function(evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode < 48 || charCode > 57) {
          evt.preventDefault();
        } else {
          return true;
        }
      });
    },
    fixUserAmount: function(userAmount) {
      this.amountIsEligible = false;
      var max = this.maxTopUp;
      var am = userAmount.toString().substring(0, 2);
      var ar = am.split("");
      var amount = "";
      for (var i = 0; i < ar.length; ++i) {
        amount = amount.concat("", ar[i]);
      }
      var amountInt = parseInt(amount);
      if (amountInt > max) {
        amount = "" + max;
      } else if (amount.length == 0) {
        amount = "";
      }
      this.userAmount = amount;

      if (parseInt(this.userAmount) >= this.minTopUp) {
        this.amountIsEligible = true;
      }
      this.selectedAmount = this.userAmount;
      this.$store.commit("setAmount", this.selectedAmount);
    },
    choseMethod(paymentOption) {
      document.getElementById(paymentOption).checked = true;
      this.paymentOption = paymentOption;
      this.hasChoosenMethod = true;
      console.log(
        "hasChosenMethod : " +
          this.hasChoosenMethod +
          "amountIsEligible: " +
          this.amountIsEligible
      );
    },
    pay() {
      if (this.amountIsEligible && this.hasChoosenMethod) {
        var getCardsAndRecurringInfoResponse = sessionStorage.getItem(
          "getCardAndRecurringInfo_" + "F2G_" + this.token
        );
        var self = this;

        if (getCardsAndRecurringInfoResponse == null) {
          this.$store.commit("showLoader");

          axios({
            method: "post",
            url: "/epayments/getCardAndRecurringInfo",
            data: {
              applicationName: this.$store.state.applicationName,
              referrer: "localhost",
              type: this.getUserProfileAndTariffsObject.type,
              externalToken: this.token,
              msisdn: this.getUserProfileAndTariffsObject.msisdn,
              msisdnActivationDate: this.getUserProfileAndTariffsObject
                .activationDate
            }
          })
            .then(response => {
              console.log(
                "getCardAndRecurringInfo response: " +
                  JSON.stringify(response.data)
              );

              if (response.data.result == "OK") {
                sessionStorage.setItem(
                  "getCardAndRecurringInfo_" + "F2G_" + self.token,
                  JSON.stringify(response.data)
                );
                this.$store.commit("setCardAndRecurringInfo", response.data);

                this.chooseFlowForPayment();
              } else {
                console.log("error in getCardAndRecurringInfo");
                this.$store.commit("hideLoader");
                this.$store.commit("showErrorComponent", true);
              }
            })
            .catch(error => {
              console.log(
                "getCardAndRecurringInfo responded with error: " + error
              );
              this.$store.commit("hideLoader");
              this.$store.commit("showErrorComponent", true);
            });
        } else {
            this.$store.commit(
              "setCardAndRecurringInfo",
              JSON.parse(getCardsAndRecurringInfoResponse)
            );
            this.$store.commit("hideLoader");

        }
      }
    },
    chooseFlowForPayment() {
      if (
        this.selectedAmount >= this.minTopUp &&
        this.selectedAmount <= this.maxTopUp
      ) {
        if (document.getElementById("Credit").checked) {
          this.initiatePaymentNative();
        } else if (document.getElementById("Paypal").checked) {
          console.log("this.paypalPaymentStart()");
          this.paypalPaymentStart();
        } else {
          console.log("no choosen method is selected");
        }
      } else {
        console.log("the choosen amount is invalid");
      }
    },
    initiatePaymentNative: function() {
      //this.$store.commit('showLoader');
      var self = this;
      axios({
        method: "post",
        url: "/epayments/initiatePaymentNative",
        data: {
          applicationName: this.$store.state.applicationName,
          merchantRef: this.cardAndRecurringInfoObject.merchantRef,
          secToken: this.cardAndRecurringInfoObject.secToken,
          transactionCode: this.cardAndRecurringInfoObject.transactionCode,
          amount: this.selectedAmount,
          customerCode: this.$store.state.customerCode,
          customerName: this.$store.state.customerName,
          invoiceNumber: null,
          callbackURI: null,
          hostName: this.$store.state.hostName,
          locale: this.getLocale,
          msisdn: this.getUserProfileAndTariffsObject.msisdn,
          msisdnActivationDate: this.getUserProfileAndTariffsObject
            .activationDate,
          postalCode: null,
          sendCallback: "false",
          taxNumber: this.$store.state.taxNumber,
          transferMsisdn: this.getUserProfileAndTariffsObject.msisdn,
          twoStagesFlow: "false",
          currency: "EUR",
          userName: this.$store.state.guid,
          saveCard: "false",
          savedCard: null,
          useSavedCard: "false",
          minNumberOfInstalments: 0,
          maxNumberOfInstalments: 0,
          numberOfInstalments: 0,
          recurringType: "",
          recurringDate: "",
          recurringThreshold: "",
          recurringService: "",
          recurringAsset: "",
          requestInvoice: true,
          paymentMethod: "card",
          email: this.email,
          browser: this.determineBrowser(),
          screenWidth : window.screen.width,
          screenHeight: window.screen.height
        }
      })
        .then(response => {
          console.log("initiatePaymentNative " + JSON.stringify(response.data));
          if (response.data.result == "OK") {
            //clear service response from session storage

            sessionStorage.removeItem(
              "getUserProfileAndTariffs_" + "F2G_" + self.token
            );

            sessionStorage.removeItem(
              "getCardAndRecurringInfo_" + "F2G_" + self.token
            );
            ///sessionStorage.removeItem('getPaypalToken_' + "F2G_" + this.token);

            //Add a key to session storage to know if we have returned from bank
            sessionStorage.setItem(
              "activeFlow_" + "F2G_" + self.token,
              "false"
            );

            /* redirect to bank*/

            console.log("initiate payment done");
            if (this.getLocale == "el") {
              var lang = "gr";
            } else {
              lang = this.getLocale;
            }
            var paidAmount =
              response.data.paidAmount != undefined
                ? response.data.paidAmount
                : this.selectedAmount;

            //window.location.href = "/etopup/begin?merchantRef=" + this.getMerchantRefObject.merchantRef + "&secToken=" + this.getMerchantRefObject.secToken;

            window.location.href =
              "/" +
              lang +
              "/f2g/nbg-payments/?mid=" +
              response.data.merchantId +
              "&amount=" +
              paidAmount +
              "&sessionid=" +
              response.data.masterCardSessionId +
              "&applicationname=" +
              this.$store.state.applicationName +
              "&merchantref=" +
              this.cardAndRecurringInfoObject.merchantRef +
              "&sectoken=" +
              this.cardAndRecurringInfoObject.secToken +
              "&transactioncode=" +
              this.cardAndRecurringInfoObject.transactionCode +
              "&recurring=" +
              false +
              "&anonymous=" +
              true;
          } else {
            //Check if fraud fault
            if (response.data.fault.faultCode == 19) {
              var faultDescription = response.data.fault.faultDescription;
              this.$store.commit("hideLoader");
              console.log(faultDescription);
              this.$store.commit("showErrorComponent", true);
              this.$store.commit("setFaultDescription", faultDescription);
            } else {
              console.log(
                "initiatePaymentNative responded: " + response.data.result
              );
              this.$store.commit("hideLoader");
              this.$store.commit("showErrorComponent", true);
              console.log("initiate payment not done");
            }
          }
        })
        .catch(error => {
          this.$store.commit("hideLoader");
          this.$store.commit("showErrorComponent", true);
          console.log("initiatePaymentNative responded with error: " + error);
        });
    },
    // checkCardList: function() {
    //   if (this.cardAndRecurringInfoObject.cardList.length == 0) {
    //     this.initiatePaymentNative();
    //     console.log("length == 0");
    //   } else if (this.cardAndRecurringInfoObject.cardList.length > 0) {
    //     this.$store.commit("hideLoader");
    //     this.$store.commit("showSavedCardComponent", true);
    //     console.log("length > 0");
    //   }
    // },
    /**************************************************
     * ******************* PAYPAL *********************
     **************************************************/
    paypalPaymentStart() {
      //fault should be undefined in order to allow payment
      if (this.getUserProfileAndTariffsObject.fault == undefined) {
        this.getPaypalToken();
      } else {
        //inform user that it is not allow to procceed
        let faultDescription = this.getUserProfileAndTariffsObject.fault
          .faultDescription;
        this.$store.commit("showErrorComponent", true);
        this.$store.commit("setFaultDescription", faultDescription);
      }
    },
    getPaypalToken() {
      let self = this;
      
      /***********************************************
       * in case browser blocked popup window 
       * we store the response of get paypal token
       * in order to try again avoiding 
       * "Invalid Reload Duplicate Request id" error by calling
       * getPaypalToken for second time
       ***********************************************/
      if(this.getPaypalTokenResponse === ''){

        this.$store.commit("showLoader");

        axios({
          method: "post",
          url: "/paymentService/",
          params: {
            paymentService: "getPaypalToken",
            paymentDataObject: JSON.stringify(this.paymentInput())
          }
        })
          .then(response => {
            console.log("success token response: " + JSON.stringify(response));
            if(response.data.Status === 'SUCCESS'){

              self.getPaypalTokenResponse = response.data;

              let amount = self.selectedAmount; //if there is discount for employee this will change
              let originalAmount = self.selectedAmount;

              if(response.data.employeeAmount !== undefined){
                amount = response.data.employeeAmount;  
              }

              self.connectWithPaypal(
                  response.data.token,
                  response.data.PaymentID,
                  amount,
                  originalAmount
                );
            }else{
                this.$store.commit("showErrorComponent", true);
                this.$store.commit("hideLoader");
            }
            

          })
          .catch(error => {
            console.log("error token response: " + error);
            this.$store.commit("showErrorComponent", true);
            this.$store.commit("hideLoader");
          })
          .finally(() => {
            console.log("finally");
          });
      
      }else{
        let amount = self.selectedAmount; //if there is discount for employee this will change
        let originalAmount = self.selectedAmount;

        if(self.getPaypalTokenResponse.employeeAmount !== undefined){
          amount = self.getPaypalTokenResponse.employeeAmount;  
        }

        self.connectWithPaypal(
            self.getPaypalTokenResponse.token,
            self.getPaypalTokenResponse.PaymentID,
            amount,
            originalAmount
          );

      }
    },
    paymentInput: function() {
      let data = {
        amount: parseInt(this.selectedAmount),
        channel: "etopupF2G",
        msisdn: this.getUserProfileAndTariffsObject.msisdn,
        description: this.description(),
        transactionCode: this.cardAndRecurringInfoObject.transactionCode,
        requestInvoice: true //true or false (//always true on logged in users)
      };

      return data;
    },
    connectWithPaypal(token, paymentID, amount, originalAmount){
      let self = this;
      console.log('connectWithPaypal')

      //var paypalButton = document.querySelector('.js-one-step-button-submit');
      let braintree = require('braintree');
      let client = require('braintree-web/client');
      let paypal = require('braintree-web/paypal');

      client.create({
        authorization: token
      }, function (clientErr, clientInstance) {
        if (clientErr) {
          console.error('paypal client.create error:', clientErr);
          self.$store.commit("showErrorComponent", true);
          return;
        }
        paypal.create({
          client: clientInstance
        }, function (paypalErr, paypalInstance) {
          if (paypalErr) {
            console.error('paypal paypal.create error:', paypalErr);
            self.$store.commit("showErrorComponent", true);
            return;
          }
          //paypalButton.removeAttribute('disabled');
          // When the button is clicked, attempt to tokenize.
       
            // Because tokenization opens a popup, this has to be called as a result of
            // customer action, like clicking a button. You cannot call this at any time.
            // So flow enters here on 3 sircumstances: when user selects Pay, Cancel or X button
            //console.log("payload: "+payload);
            paypalInstance.tokenize({
              flow: 'checkout',
              amount: amount, // Required
              currency: 'EUR' // Required

              // For more tokenization options, see the full PayPal tokenization documentation
              // http://braintree.github.io/braintree-web/current/PayPal.html#tokenize
            }, function (tokenizeErr, payload) {
              //print the payload with the information we get from paypal
              console.log("payload: "+JSON.stringify(payload));
              /**************************************************
               * check if an error has accured in PayPal payment
               * or if user selected cancel or X button
               ***************************************************/
              if (tokenizeErr) {
                /**********************************************
                 * call updatePaymentStatus with status "CANCEL"
                 * to informe backend that payment was canceled
                 ************************************************/
                let data = {
                    channel: "etopupF2G",
                    paymentID: paymentID,
                    token: token.substring(0, 20),
                    //in anonymous topup call updatePaymentStatus
                    //without username
                    //userName: document.getElementById("user-info").getAttribute("data-username"),
                    status: "CANCEL"
                };

                self.updatePaymentStatus(data);

                self.$store.commit("hideLoader");
                
                if (tokenizeErr.type !== 'CUSTOMER') {
                  console.error('Error tokenizing:', tokenizeErr);
                  //check of browser has blocked the paypal popup window
                  if(tokenizeErr.details.originalError.code == 'FRAME_SERVICE_FRAME_OPEN_FAILED' 
                    || tokenizeErr.details.originalError.code == 'FRAME_SERVICE_FRAME_OPEN_FAILED_IE'           
                    || tokenizeErr.details.originalError.code == 'FRAME_SERVICE_FRAME_OPEN_FAILED_IE_BUG' ){

                      //sessionStorage.setItem('blockedByPopUp_'+channel+"_"+commonFunctions.methods.getToken(), true);
                      // Your browser blocks the paypal popup window, please change your settings to unblock it
                      self.$store.commit("hideLoader");
                      //show message
                      $('#enable-pop-up-msg').show();
                      $('html, body').animate({
                          scrollTop: $("#enable-pop-up-msg").offset().top - 150
                      }, 1000);

                  }else{
                    self.$store.commit('showErrorComponent', true);
                  }
                }else{
                  /**
                   * if user selectes cancel or X button
                   */
                  if(tokenizeErr.code == "PAYPAL_POPUP_CLOSED"){
                      //because user have used the token he cant try again
                      //if user reload the page he can try again
                      self.$store.commit("setActiveFlow", false);
                      self.$store.commit('showErrorComponent', true);
                    
                  }
                  
                } 
                      
              }else{
                //User paid successfully!!
                console.log('User paid successfully!! Got a nonce:'+ payload.nonce);
                //I got payload with information for the paypal user that paid and i will submit 
                //them to the backend
                /*_sendDataToATG(
                  payload, 
                  callback, 
                  _paymenttype, 
                  _token.substring(0, 20), 
                  channel);*/
                  //the function that does the second call
                self.submitPaypalTransaction(
                    payload, 
                    token.substring(0, 20), 
                    amount, 
                    originalAmount, 
                    paymentID
                  )
              }
            });
          })

          /*paypalButton.addEventListener('click', paypalButtonClick, false);
          if($('.js-one-step-button-submit').attr("paypal")!="enabled"){
            console.log("js-one-step-button-submi click! ");
            $('.js-one-step-button-submit').trigger('click');
            $('.js-one-step-button-submit').attr("paypal","enabled");
          }*/

        

     })
    },
    /***********************************************
    * in anonymous topup flow, 
    * call updatePaymentStatus
    * without username
    ************************************************/
    updatePaymentStatus(data){

      axios({
        method: "post",
        url: "/paymentService/",
        params: {
          paymentService: "UpdatePaymentStatus",
          paymentDataObject: JSON.stringify(data)
        }
      }).then(response => { 
          console.log("success UpdatePaymentStatus: " + JSON.stringify(response));
        })
        .catch(error => {
          console.log("error UpdatePaymentStatus: " + error);
        })
        .finally(() => {
          console.log("UpdatePaymentStatus finally");
        });
      
    },
    submitPaypalTransaction(payload, token, amount, originalAmount, paymentID){

        console.log('payload: '+JSON.stringify(payload));

        let self = this;

        this.$store.commit("showLoader");

        let data = {
          paymentID: paymentID,
          amount: amount,
          originalAmount: originalAmount,
          paymentNonce: payload.nonce,
          firstName: payload.details.firstName,
          lastName: payload.details.lastName,
          email: payload.details.email,
          payerID: payload.details.payerId,
          username: "",//anonymous
          locale: this.locale, 
          channel: "etopupF2G",
          msisdn: this.getUserProfileAndTariffsObject.msisdn,//changed for anonymous
          token: token,
          transactionCode: this.cardAndRecurringInfoObject.transactionCode,
          requestInvoice: "true", //always true
          emailTopUp: this.email,
        }

        axios({
            method: "post",
            url: "/paymentService/",
            params: {
              paymentService: "SubmitPaypalTransaction",
              paymentDataObject: JSON.stringify(data)
            }
          }).then(response => {
              console.log("success SubmitPaypalTransaction: " + JSON.stringify(response));
              if(response.data.Status=="SUCCESS"){
                //redirect to success page
                window.location.href =
                    window.location.href 
                    + '/?merchantRef=' + paymentID
                    + '&status=OK' 
                    + '&msisdn=' + this.getUserProfileAndTariffsObject.msisdn//changed for anonymous
                    + '&amount=' + originalAmount
                    + '&transactionCode=' + self.cardAndRecurringInfoObject.transactionCode ;
              }else{
                //error smt went
                //show overlay
                this.$store.commit("showErrorComponent", true);
              }
                        
            })
            .catch(error => {
              console.log("error UpdatePaymentStatus: " + error);
              this.$store.commit("showErrorComponent", true);
            })
            .finally(() => {
              console.log("UpdatePaymentStatus finally");
              this.$store.commit("hideLoader");
            });
  

    },
    /*
     * Constructs the description for the Paypal Payment
     */
    description() {
      let d = new Date();
      let timeMilis = d.getTime();
      let dateSTR = this.dateFormatDMYslashes_HM_S(timeMilis);
      let message =
        "TS:" +
        this.getUserProfileAndTariffsObject.msisdn +
        ", AMT:" +
        this.selectedAmount +
        ", REF:PAYMENT_ID, Date:" +
        dateSTR;

      return message;
    },
    dateFormatDMYslashes_HM_S(stringDate) {
      //uses dots
      var date = new Date(stringDate); //takes as a param the date in string format
      var returnDate =
        this.addZero(date.getDate()) +
        "/" +
        (date.getMonth() + 1) +
        "/" +
        date.getFullYear() +
        " " +
        this.addZero(date.getHours()) +
        ":" +
        this.addZero(date.getMinutes()) +
        ":" +
        this.addZero(date.getSeconds()); //cuts the information needed from date
      return returnDate;
    },
    addZero(i) {
      //add a "0" if hour or minute is one digit i.e: 9 -> 09
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    determineBrowser() {
      var nAgt = navigator.userAgent ? navigator.userAgent : "";
      var browserName  = navigator.appName ? navigator.appName : "";
      var fullVersion  = ''+parseFloat(navigator.appVersion); 
      var majorVersion = parseInt(navigator.appVersion,10);
      var nameOffset,verOffset,ix;

      // In Opera, the true version is after "Opera" or after "Version"
      if ((verOffset=nAgt.indexOf("Opera"))!=-1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset+6);
        if ((verOffset=nAgt.indexOf("Version"))!=-1) 
          fullVersion = nAgt.substring(verOffset+8);
      }
      // In Opera, the true version might also be after "OPR" or after "Version"
      else if ((verOffset=nAgt.indexOf("OPR"))!=-1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset+4);
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
        browserName = "Internet Explorer";
        fullVersion = nAgt.substring(verOffset+5);
      }
      // In MSIE 11, the true version is rv "Trident" in userAgent
      else if ((verOffset=nAgt.indexOf("Trident/7.0"))!=-1) {
        browserName = "Internet Explorer";
        fullVersion = "11.0";
      }
      //start of handling all Edge cases
      else if ((verOffset=nAgt.indexOf("Edg"))!=-1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset+4);
      }
      else if ((verOffset=nAgt.indexOf("Edge"))!=-1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset+5);
      }
      else if ((verOffset=nAgt.indexOf("EdgA"))!=-1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset+5);
      }
      else if ((verOffset=nAgt.indexOf("EdgiOS"))!=-1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset+7);
      }
      // In Chrome, the true version is after "Chrome" 
      else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset+7);
      }
      // In Safari, the true version is after "Safari" or after "Version" 
      else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset+7);
        if ((verOffset=nAgt.indexOf("Version"))!=-1) 
          fullVersion = nAgt.substring(verOffset+8);
      }
      // In Firefox, the true version is after "Firefox" 
      else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
          browserName = "Firefox";
          fullVersion = nAgt.substring(verOffset+8);
      }
      // In most other browsers, "name/version" is at the end of userAgent 
      else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) < (verOffset=nAgt.lastIndexOf('/')) ) {
          browserName = nAgt.substring(nameOffset,verOffset);
          fullVersion = nAgt.substring(verOffset+1);
          if (browserName.toLowerCase()==browserName.toUpperCase()) {
            browserName = navigator.appName;
          }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix=fullVersion.indexOf(";"))!=-1)
          fullVersion=fullVersion.substring(0,ix);
      if ((ix=fullVersion.indexOf(" "))!=-1)
          fullVersion=fullVersion.substring(0,ix);

      majorVersion = parseInt(''+fullVersion,10);
      if (isNaN(majorVersion)) {
          fullVersion  = ''+parseFloat(navigator.appVersion); 
          majorVersion = parseInt(navigator.appVersion,10);
      }


      return browserName + ' ' + fullVersion;
    },
  }
};
</script>